import React from 'react';

import EmojiCasualIcon from '@atlaskit/icon/core/emoji-casual';

export const ToneCasualIcon = (): React.JSX.Element => (
	<EmojiCasualIcon color="currentColor" label="" spacing="spacious" />
);
